import io from "socket.io-client";
import dotenv from "dotenv";
dotenv.config();

export const socket = io(process.env.REACT_APP_LIVE_PRICE_SOCKET);
export const socket_leaderboard = io(process.env.REACT_APP_LIVE_LEADERBOARD);

// useEffect(()=>{
//   socket.on("connect", (data) => {
//     console.log("getting coins........")
//     let liveData = {};
//     for (const key in data) {
//       liveData = { ...liveData, [key]: formatPrice(data[key]) };
//     }
//     dispatch({ type: SET_LIVE_PRICE, payload: liveData });
//   });

//   // unsubscribe from event for preventing memory leaks
//   return(() => {socket.close()});
// },[])

// useEffect(()=>{
//     socket.on("connect", (data) => {
//       console.log("getting coins........")
//       let liveData = {};
//       for (const key in data) {
//         liveData = { ...liveData, [key]: formatPrice(data[key]) };
//       }
//       dispatch({ type: SET_LIVE_PRICE, payload: liveData });
//     });

//     // unsubscribe from event for preventing memory leaks
//     return(() => {socket.close()});
//   },[])

//   useEffect(() => {
//    if(!state.cryptoData || !state.cryptoData.length > 0){
//     socket.emit("coinPerPage", { pageNo: page, limit: 100 });
//     socket.on("coinPerPageResponse", (data) => { console.log(data);
//       dispatch({ type: GET_GLOBAL_TICKER, payload: data });
//     });
//    }
//    if(state.cryptoData&& state.cryptoData.length > 0){
//     getNamesOfDisplayedCryptoData()
//    }
//   if(state.cryptoStr&&state.cryptoData&& state.cryptoData.length > 0){
//     socket.emit("sparkLineData", { timeFrame: "6mSparkline", coins: state.cryptoStr })
//       socket.on("sparkLineDataResponse", (data) => {console.log(data);
//         dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: data }) });
//   }

//     // code to send request for coinPerPage
//     // const coinPerPageCaller =

//     // code to send request for sparkLineData
//     // const sparklineDataCaller =

//       // to stop sending request for coinPerPage
//       // clearInterval(coinPerPageCaller);
//       // clearInterval(sparklineDataCaller );
//        // to stop sending request for sparkLineData clearInterval(sparklineDataCaller);
//       // });
//       // you will get the response for coinPerPage here

//       // you will get the response for sparkLineData here

//   return ()=>socket.close()
//   },[state.cryptoData,page,state.cryptoStr])

// useEffect(()=>{
//   if(state.cryptoStr){
//     console.log(state.cryptoStr)
//     socket.emit("sparkLineData", { timeFrame: "7dSparkline", coins:state.cryptoStr?state.cryptoStr:'BTC' })
//     socket.on("sparkLineDataResponse", (data) => {
//       dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: data })
//     })
//   }

// },[state.cryptoStr])

// useEffect(() => {
//  if(!state.cryptoData || !state.cryptoData.length > 0){
//   socket.emit("coinPerPage", { pageNo: page+1, limit: 100 });
//   socket.on("coinPerPageResponse", (data) => { console.log(data);
//     dispatch({ type: GET_GLOBAL_TICKER, payload: data });
//   });
//  }
//  if(state.cryptoData&& state.cryptoData.length > 0){
//   getNamesOfDisplayedCryptoData()
//  }
// if(state.cryptoStr&&state.cryptoData&& state.cryptoData.length > 0){
//   console.log("establishing socket conn",state.cryptoStr)
//   socket.emit("sparkLineData", { timeFrame: "6mSparkline", coins: state.cryptoStr })
//     socket.on("sparkLineDataResponse", (data) => {
//       console.log(data+" sparklinedata");
//       dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: data }) });
// }

//  socket.emit("sparkLineData", { timeFrame: "6mSparkline", coins: "BTC" })
//   socket.on("sparkLineDataResponse", (data) => {
//     console.log(JSON.stringify(data)+" sparklinedata");
//   })

// code to send request for coinPerPage
// const coinPerPageCaller =

// code to send request for sparkLineData
// const sparklineDataCaller =

// to stop sending request for coinPerPage
// clearInterval(coinPerPageCaller);
// clearInterval(sparklineDataCaller );
// to stop sending request for sparkLineData clearInterval(sparklineDataCaller);
// });
// you will get the response for coinPerPage here

// you will get the response for sparkLineData here

// },[state.cryptoData,page,state.cryptoStr])

// useEffect(() => {
//  if(!state.cryptoData || !state.cryptoData.length > 0){
//   socket.emit("coinPerPage", { pageNo: page, limit: 100 });
//   socket.on("coinPerPageResponse", (data) => { console.log(data);
//     dispatch({ type: GET_GLOBAL_TICKER, payload: data });
//   });
//  }
//  if(state.cryptoData&& state.cryptoData.length > 0){
//   getNamesOfDisplayedCryptoData()
//  }
// if(state.cryptoStr&&state.cryptoData&& state.cryptoData.length > 0){
//   socket.emit("sparkLineData", { timeFrame: "6mSparkline", coins: state.cryptoStr })
//     socket.on("sparkLineDataResponse", (data) => {console.log(data);
//       dispatch({ type: GET_CRYPTO_COINS_SPARKLINES, payload: data }) });
// }

// code to send request for coinPerPage
// const coinPerPageCaller =

// code to send request for sparkLineData
// const sparklineDataCaller =

// to stop sending request for coinPerPage
// clearInterval(coinPerPageCaller);
// clearInterval(sparklineDataCaller );
// to stop sending request for sparkLineData clearInterval(sparklineDataCaller);
// });
// you will get the response for coinPerPage here

// you will get the response for sparkLineData here

// return ()=>socket.close()
// },[state.cryptoData,page,state.cryptoStr])
